"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = require("../Button/Button");

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DialogActions = function (_PureComponent) {
  _inherits(DialogActions, _PureComponent);

  function DialogActions() {
    _classCallCheck(this, DialogActions);

    return _possibleConstructorReturn(this, (DialogActions.__proto__ || Object.getPrototypeOf(DialogActions)).apply(this, arguments));
  }

  _createClass(DialogActions, [{
    key: "renderCancelButton",
    value: function renderCancelButton() {
      if (!this.props.hasCancel) return null;
      return _react2.default.createElement(
        _Button2.default,
        { className: "aclui-dialog-actions__cancel", size: "large", type: "minor", onClick: this.props.onCancel },
        this.props.labelCancel
      );
    }
  }, {
    key: "renderConfirmButton",
    value: function renderConfirmButton() {
      if (!this.props.hasConfirm) return null;
      return _react2.default.createElement(
        _Button2.default,
        {
          className: "aclui-dialog-actions__confirm",
          isDisabled: this.props.isDisabled,
          onClick: this.props.onConfirm,
          size: "large",
          type: this.props.isDestructive ? "destructive" : "primary"
        },
        this.props.labelConfirm
      );
    }
  }, {
    key: "renderDeclineButton",
    value: function renderDeclineButton() {
      if (!this.props.hasDecline) return null;
      return _react2.default.createElement(
        _Button2.default,
        {
          className: "aclui-dialog-actions__decline",
          isDisabled: this.props.isDisabled,
          onClick: this.props.onDecline,
          size: "large"
        },
        this.props.labelDecline
      );
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.hasConfirm && !this.props.hasCancel && !this.props.hasDecline) return null;
      return _react2.default.createElement(
        "div",
        { className: "aclui-dialog-actions " + this.props.className },
        this.renderConfirmButton(),
        this.renderDeclineButton(),
        this.renderCancelButton()
      );
    }
  }]);

  return DialogActions;
}(_react.PureComponent);

DialogActions.propTypes = {
  /** Optional custom classes. */
  className: _propTypes2.default.string,

  /** If a cancel button should be shown. */
  hasCancel: _propTypes2.default.bool,

  /** If a primary action button should be shown. */
  hasConfirm: _propTypes2.default.bool,

  /** If a secondary generic button should be shown. */
  hasDecline: _propTypes2.default.bool,

  /** If the primary button is a destructive action. */
  isDestructive: _propTypes2.default.bool,

  /** If the primary and secondary buttons are disabled. */
  isDisabled: _propTypes2.default.bool,

  /** Text for cancel button. */
  labelCancel: _propTypes2.default.string,

  /** Text for primary action button. */
  labelConfirm: _propTypes2.default.string,

  /** Text for a secondary generic button. */
  labelDecline: _propTypes2.default.string,

  /** Function to call when cancel button is clicked. */
  onCancel: _propTypes2.default.func,

  /** Function to call when primary button is clicked. */
  onConfirm: _propTypes2.default.func,

  /** Function to call when secondary button is clicked. */
  onDecline: _propTypes2.default.func
};

DialogActions.defaultProps = {
  className: "",
  hasCancel: true,
  hasConfirm: true,
  hasDecline: false,
  isDestructive: false,
  isDisabled: false,
  labelCancel: "Cancel", // TODO: i18n
  labelConfirm: "Save", // TODO: i18n
  labelDecline: "Don't Save", // TODO: i18n
  onCancel: function onCancel() {},
  onConfirm: function onConfirm() {},
  onDecline: function onDecline() {}
};

exports.default = DialogActions;